import { Icon } from './ui/Icon';

/**
 * Marks an alliance leader wherever their name is rendered — the roster,
 * the browse directory, and the alliance overview. One component so the
 * icon and its accessible label can never drift between those three.
 */
export default function AllianceLeaderIcon() {
    return (
        <span
            className="text-status-warning shrink-0 inline-flex"
            title="Alliance leader"
            aria-label="Alliance leader"
            role="img"
            data-testid="alliance-leader-icon"
        >
            <Icon name="alliance-leader" size={14} aria-hidden="true" />
        </span>
    );
}
